import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENV } from '../core-ng/injection-token';
import { Observable, Subject } from 'rxjs';
import { SurveyListOption } from '@hyper-inferno/survey-elements-core';

@Injectable({
  providedIn: 'root',
})
export class SurveyListOptionService {
  private http = inject(HttpClient);
  environment = inject(ENV);

  getListOptions(list_id: string): Observable<SurveyListOption[]> {
    return this.http.post<SurveyListOption[]>(
      `${this.environment.consoleApi}/survey-builder/get-list-options`,
      { list_id },
    );
  }
  createListOption(payload: {
    list_id: string;
    option_key: number;
    option_display: string;
    is_mutually_exclusive: boolean;
    is_open_ended: boolean;
  }): Observable<any> {
    return this.http.post(
      `${this.environment.consoleApi}/survey-builder/create-list-option`,
      payload,
    );
  }

  deleteListOption(payload: { id: string; list_id: string }): Observable<any> {
    return this.http.post(
      `${this.environment.consoleApi}/survey-builder/delete-list-option`,
      payload,
    );
  }
  updateOptionRanks(
    payload: { id: string; option_key: number,listId:string }[],
  ): Observable<unknown> {
      return this.http.post(
      `${this.environment.consoleApi}/survey-builder/reorder-list-option`,
      payload,
    );
  }

  private listUpdatedSource = new Subject<string>(); 
  listUpdated$ = this.listUpdatedSource.asObservable();
  
  notifyListUpdated(listId: string) {
    this.listUpdatedSource.next(listId);
  }


createBulkOptions(list_id: string, options: string[]): Observable<SurveyListOption[]> {
  return this.http.post<SurveyListOption[]>(
    `${this.environment.consoleApi}/survey-builder/create-bulk-options`,
    { 
      list_id: list_id, 
      options: options 
    }
  );
}
}
